import { createElement } from "react";
import { User } from "lucide-react";

// A drop-based 3-wide matrix. Boxes fill in drop-time order (BFS): 3 -> 9 -> 27.
// Every active branch is padded to `width` slots so empty positions are visible.
function Node({ node, width, depth, maxDepth }) {
  const isRoot = node.__root;
  const isEmpty = node.empty;
  const kids = node.children || [];
  const hasRealChild = kids.length > 0;
  const renderChildren = !isEmpty && depth < maxDepth && (isRoot || hasRealChild);

  const slots = [];
  if (renderChildren) {
    for (let i = 0; i < width; i++) {
      slots.push(kids[i] || { id: `empty-${node.id}-${i}`, empty: true, children: [] });
    }
  }

  return (
    <div className="flex flex-col items-center">
      <div className={`flex flex-col items-center gap-1 rounded-xl px-3 py-2 border ${
        isEmpty ? "border-dashed border-white/10 bg-white/[0.015]"
        : isRoot ? "border-cyan-500/60 bg-cyan-500/15"
        : node.own ? "border-violet-500/50 bg-violet-500/15"
        : "border-emerald-500/40 bg-emerald-500/10"}`}>
        <span className={`inline-flex h-8 w-8 items-center justify-center rounded-full ${
          isEmpty ? "bg-white/5 text-slate-600"
          : isRoot ? "bg-cyan-400 text-slate-900"
          : node.own ? "bg-violet-400 text-slate-900"
          : "bg-emerald-500 text-slate-900"}`}>
          <User className="h-4 w-4" />
        </span>
        <span className={`text-[0.65rem] max-w-[80px] truncate ${isEmpty ? "text-slate-600" : "text-white"}`}>
          {isEmpty ? "Empty" : node.name}
        </span>
        {isRoot && <span className="text-[0.55rem] uppercase tracking-wide text-cyan-300/90">Holder</span>}
        {!isRoot && !isEmpty && node.own && <span className="text-[0.55rem] uppercase tracking-wide text-violet-300/90">own drop</span>}
      </div>
      {slots.length > 0 && (
        <>
          <div className="h-4 w-px bg-white/15" />
          <div className="flex gap-4 sm:gap-8">
            {slots.map((c) => (
              <div key={c.id} className="relative flex flex-col items-center">
                <div className="h-4 w-px bg-white/15" />
                {createElement(Node, { node: c, width, depth: depth + 1, maxDepth })}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export function MatrixTree({ root, width = 3, maxDepth = 3 }) {
  return (
    <div className="min-w-max flex justify-center py-4">
      <Node node={{ ...root, __root: true }} width={width} depth={0} maxDepth={maxDepth} />
    </div>
  );
}
